import type {CampaignProps} from '@/types/campaign';

function resolveCompensationType(
  campaign: Pick<
    CampaignProps,
    | 'creatorCompensationType'
    | 'suggestedCostForCreationsMin'
    | 'suggestedCostForCreations'
    | 'fixedCostForCreations'
  >
): 'range' | 'fixed' | null {
  const type = campaign.creatorCompensationType;
  if (type === 'range' || type === 'fixed') {
    return type;
  }
  if (
    campaign.suggestedCostForCreationsMin != null ||
    campaign.suggestedCostForCreations != null
  ) {
    return 'range';
  }
  if (campaign.fixedCostForCreations != null) {
    return 'fixed';
  }
  return null;
}

export default resolveCompensationType;
